module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"specific-indicators":"Indicateurs spécifiques","all-indicators":"Tous les indicateurs"},"en":{"specific-indicators":"Specific indicators","all-indicators":"All indicators"}}')
  delete Component.options._Ctor
}
